import { NavigationInstruction, Next, PipelineStep } from 'aurelia-router';

/**
 * Store some session information in the browser
 */
export class LoggingStep implements PipelineStep {
	public run(instruction: NavigationInstruction, next: Next): Promise<any> {
		// Expects pages to have a single route. Used by the helpfile to get location.
		const pageName = instruction.config.route;
		sessionStorage.setItem(
			'page_name',
			typeof pageName === 'string' ? pageName : '',
		);
		return next();
	}
}
